import React, { useState } from "react";

import { formatCalendarDate, currencyFormat, formatPhoneNumber } from "../../../Utils/helper";
import EditReportModal from "../ReportModals/EditReportModal";
import ConfirmDeletePopup from "../ReportModals/ConfirmDeletePopup";
import { api_without_cancellation } from "../../../api/api";

function ReportSummaryTable({ reports = [], isDummy = false, fetchReports }) {
  // Styles for the table rows
  const tableRowStyle = {
    height: "25px",
    lineHeight: "25px",
  };

  const emptyRowStyle = {
    height: "25px",
    width: "100%",
  };
  const [showEdit, setShowEdit] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [forDeleteReportId, setForDeleteReportId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleCloseFucton = () => {
    setShowEdit(false);
    setSelectedReport(null);
    setForDeleteReportId(null);
  };
  // Check if we should show "No Report Taken"
  const shouldShowNoReport = isDummy || !reports || reports.length === 0;
  const handleDeleteSubmission = async () => {
    const response = await api_without_cancellation.delete(`/api/report/${forDeleteReportId}/`);
    if (response.status === 204) {
      setShowDeleteConfirm(false);
      fetchReports();
    }
  };
  const showDeleteConfirmPopup = () => {
    setShowDeleteConfirm(true);
    setSelectedReport(null);
    setShowEdit(false);
  };

  // Function to render data rows
  const renderDataRow = (report, index) => (
    <tr
      onClick={() => {
        setShowEdit(true);
        setSelectedReport(report);
        setForDeleteReportId(report?.id);
      }}
      key={`report-${index}`}
      style={tableRowStyle}
    >
      {/* Number */}
      <td
        className="text-center"
        style={{
          minWidth: "25px",
          width: "25px",
          maxWidth: "25px",
          color: "var(--primary-25)",
          fontWeight: "600",
        }}
      >
        {index + 1}
      </td>

      {/* Report Type */}
      <td className="td-autosize report-type-name p-l-5">
        <div
          className="d-flex align-items-center p-l-5 p-r-5"
          style={{
            fontWeight: "600",
          }}
        >
          <span className="text-truncate ">{report.report_type_name || ""}</span>
        </div>
      </td>

      <td />

      {/* Reporting Agency */}
      <td
        className="td-autosize agency-name"
        style={{
          fontWeight: "600",
        }}
      >
        <div className="text-truncate p-l-5 p-r-5">{report.reporting_agency_name || ""}</div>
      </td>

      {/* <td /> */}

      {/* Reporting Agency Phone Number */}
      <td
        className="text-end phone-col"
        style={{
          fontWeight: "600",
        }}
      >
        <div className="text-truncate p-l-5 p-r-5">
          {report?.phone ? `${formatPhoneNumber(report.phone)}` : ""}
        </div>
      </td>

      <td />

      {/* Cost */}
      <td
        className="text-end cost-col"
        style={{
          fontWeight: "600",
        }}
      >
        <div className="p-l-5 p-r-5">{`${currencyFormat(report?.cost)}`}</div>
      </td>

      <td
        className="text-end completed-col"
        style={{
          fontWeight: "600",
        }}
      >
        <div className="p-l-5 p-r-5">
          {report.completed ? formatCalendarDate(report.completed) : ""}
        </div>
      </td>

      {/* Ordered */}
      <td
        className="text-end ordered-col"
        style={{
          fontWeight: "600",
        }}
      >
        <div className="p-l-5 p-r-5">
          {report.date_ordered ? formatCalendarDate(report.date_ordered) : ""}
        </div>
      </td>

      {/* <td /> */}

      {/* Date Received */}
      <td
        className="text-end received-col"
        style={{
          fontWeight: "600",
        }}
      >
        <div className="p-l-5 p-r-5">
          {report.date_recieved ? formatCalendarDate(report.date_recieved) : ""}
        </div>
      </td>
    </tr>
  );

  // Function to render empty rows to reach minimum of 5 rows
  const renderEmptyRows = (dataLength) => {
    const minRows = 5;
    const emptyRowsCount = Math.max(0, minRows - dataLength);

    return Array.from({ length: emptyRowsCount }, (_, index) => (
      <tr key={`empty-${index}`} style={tableRowStyle}>
        <td colSpan={12} className="empty-row">
          <div style={emptyRowStyle}>{/* Empty row */}</div>
        </td>
      </tr>
    ));
  };

  return (
    <div className="custom-tab lit-custom-tab w-100">
      {shouldShowNoReport ? (
        // Show "No Report Taken" message
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "150px" }}
        >
          <span className="color-grey-2">No Report Taken</span>
        </div>
      ) : (
        // Table
        <div className="table-responsive overflow-hidden">
          <table className="table table-borderless table-striped table-treatment has-height-25">
            <thead>
              <tr id="tb-header">
                <th
                  className="text-center"
                  style={{
                    minWidth: "25px",
                    width: "25px",
                    maxWidth: "25px",
                  }}
                >
                  {/* Number Header */}
                </th>
                <th className="td-autosize color-grey-2 report-type-name text-center p-l-5">
                  Report Type
                </th>
                <th className="flex-g-1" />
                <th className="text-center td-autosize agency-name color-grey-2">
                  Reporting Agency
                </th>
                {/* <th /> */}
                <th className="text-center td-autosize phone-col color-grey-2">Phone Number</th>
                <th className="flex-g-1" />
                <th className="text-center td-autosize cost-col color-grey-2">Cost</th>
                <th className="text-center td-autosize completed-col color-grey-2">Completed</th>
                <th className="text-center td-autosize ordered-col color-grey-2">Ordered</th>
                {/* <th /> */}
                <th className="text-center td-autosize received-col color-grey-2">Received</th>
              </tr>
            </thead>
            <tbody>
              {reports?.map((report, index) => renderDataRow(report, index))}
              {renderEmptyRows(reports?.length || 0)}
            </tbody>
          </table>

          {showEdit && (
            <EditReportModal
              show={showEdit}
              handleClose={handleCloseFucton}
              report={selectedReport}
              onShowDeleteConfirmPopup={showDeleteConfirmPopup}
              activeTab={"report-information"}
              onFetchReports={fetchReports}
            />
          )}

          {showDeleteConfirm && (
            <ConfirmDeletePopup
              handleDeleteSubmission={handleDeleteSubmission}
              handleClose={() => setShowDeleteConfirm(false)}
              entity="INCIDENT REPORT"
            />
          )}
        </div>
      )}
    </div>
  );
}

export default React.memo(ReportSummaryTable);
